export var errorMessages = {
  '001': function _() {
    return '[msg-central]: Seems like you have not used MsgProvider as an ancestor, It is suggested that wrap your root component in MsgProvider. ';
  }
};
export var MSG_CENTRAL_STORAGE_KEY = 'weee@msg-central';